let ENGLISH_LETTERS = "[a-zA-Z\\.]";
let ENGLISH_DIGITS = "[0-9\\.]";
let ARABIC_LETTERS = "[\u0620-\u064A]";
let ARABIC_EXT_LETTERS = "[\u0670-\u06D5]";
let ARABIC_DIGITS = "[\u0660-\u0669\\.]";
let ARABIC_EXT_DIGITS = "[\u06F0-\u06F9\\.]";
let PUNCTUATION = "[\\-,\\.\u060C():,\\[\\]_!?؟]";
let SPACE = "[\\s\u200b\u200c]";
let TAB_AND_NEW_LINE = "[\\t\\r\\n]";

let NAME_FA_ = "(" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + ")" +
"(" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + ")";

let NAME_FA_NUMBER_FA_ = "(" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + ")" +
"(" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + "|" + ARABIC_DIGITS + "|" + ARABIC_EXT_DIGITS + "|" + ENGLISH_DIGITS + ")";

let TEXT_FA_ = "(" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + ")" +
"(" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + "|" + PUNCTUATION +
"|" + TAB_AND_NEW_LINE + "|" + ARABIC_DIGITS + "|" + ARABIC_EXT_DIGITS + "|" + ENGLISH_DIGITS + ")";

let TITLE_EN_FA_ = "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + "|" + PUNCTUATION +
"|" + ENGLISH_DIGITS + "|" + ARABIC_DIGITS + "|" + ARABIC_EXT_DIGITS + ")";

let patterns = {

    PHONE_NUMBER_EN : "[0][9][0-9]{9}",
    PHONE_NUMBER_EN_DESC : "باید ۱۱ رقمی بوده و با ۰۹ شروع شود و کاراکترها انگلیسی باشد",

    PHONE_NUMBER_EN_FA : "[0\u0660\u06F0][9\u0669\u06F9]" +
        "[0-9\u0660-\u0669\u06F0-\u06F9]{9}",
    PHONE_NUMBER_EN_FA_DESC : "شماره موبایل باید ۱۱ رقمی بوده و با ۰۹ شروع شود",


    TELEPHONE_EN_TEHRAN : "[0-9]{8}",
    TELEPHONE_EN : "[0][0-9]{6,10}",
    TELEPHONE_EN_DESC : "باید با 0 شروع شده و بین ۷ تا ۱۱ رقم باشد و کاراکترها انگلیسی باشد",

    TELEPHONE_EN_FA : "[0\u0660\u06F0][0-9\u0660-\u0669\u06F0-\u06F9]{6,10}",
    TELEPHONE_EN_FA_DESC : "شماره تلفن باید با ۰ شروع شده و بین ۷ تا ۱۱ رقم باشد",

    EMAIL : "^(([^@]+[@][^@]+[\\.][^@]+)$|$)",
    EMAIL_DESC : "باید با کاراکتر الفبایی یا عددی شروع شده، حاوی @ بوده و با نام یک دامنه پایان یابد",

    NATIONAL_ID_EN : "[0-9\u0660-\u0669\u06F0-\u06F9]{10}",
    NATIONAL_ID_EN_DESC : "کدملی باید ۱۰ رقم باشد",

    POSTAL_CODE_EN : "[0-9\u0660-\u0669\u06F0-\u06F9]{10}",
    POSTAL_CODE_EN_DESC : "کد پستی باید ۱۰ رقم باشد",

    BANK_ACCOUNT_NUMBER_EN : "[0-9\u0660-\u0669\u06F0-\u06F9]{4,24}",
    BANK_ACCOUNT_NUMBER_EN_DESC : "شماره حساب باید بین ۴ تا ۲۴ رقم باشد",

    BANK_SHEBA_NUMBER_EN : "[0-9\u0660-\u0669\u06F0-\u06F9]{24}",
    BANK_SHEBA_NUMBER_EN_DESC : "شماره شبا باید ۲۴ رقمی باشد",

    BANK_CARD_NUMBER_EN : "[0-9\u0660-\u0669\u06F0-\u06F9]{16}",
    USERNAME : "([A-Z]|[a-z])+([A-Z]|[a-z]|[0-9]|\u002E){1,62}",
    BANK_CARD_NUMBER_EN_DESC : "شماره کارت باید ۱۶ رقمی باشد",


    NAME_NUMBER_FA : "(" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + ")" +
        "(" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + "|" + ARABIC_DIGITS + "|" + ARABIC_EXT_DIGITS + "|" + ENGLISH_DIGITS + "){0,24}",
    DESC_NAME_NUMBER_FA : "باید حاوی حروف و اعداد فارسی بوده، با حرف شروع شود و طول ان حداکثر ۲۵ کاراکتر باشد",

    NAME_EN_FA : "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + ")" +
        "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + "){0,24}",


    NAME_FA : NAME_FA_ + "*",
    NAME_FA_DESC : "باید حاوی حروف فارسی باشد",

    NAME_FA_SMALL : NAME_FA_ + "{1,29}",
    NAME_ALIAS_SMALL_DESC : "نام مستعار باید حاوی حروف فارسی باشد و طول آن حداکثر ۳۰ کاراکتر باشد",
    ADDRESS_TITLE_DESC : "عنوان آدرس باید حاوی حروف فارسی و انگلیسی باشد و طول آن حداکثر ۳۰ کاراکتر باشد",
    ADDRESS_DESC : "آدرس باید حاوی حروف فارسی و انگلیسی باشد و طول آن حداکثر ۳۰ کاراکتر باشد",
    NAME_FIRST_NAME_SMALL_DESC : "نام باید حاوی حروف فارسی باشد و طول آن حداکثر ۳۰ کاراکتر باشد",
    NAME_LAST_NAME_SMALL_DESC : "نام خانوادگی باید حاوی حروف فارسی باشد و طول آن حداکثر ۳۰ کاراکتر باشد",
    NAME_BANK_NAME_SMALL_DESC : "نام بانک باید حاوی حروف فارسی باشد و طول آن حداکثر ۳۰ کاراکتر باشد",
    NAME_FOOD_NAME_SMALL_DESC : "نام غذا باید حاوی حروف فارسی باشد و طول آن حداکثر ۳۰ کاراکتر باشد",

    NAME_EN_FA_NUMBER_EN_FA : "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + ")" +
        "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + "|" + ENGLISH_DIGITS + "|" + ARABIC_DIGITS + "|" + ARABIC_EXT_DIGITS + "){1,29}",

    NAME_EN_FA_NUMBER_EN_FA_ADDRESS : "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + ")" +
        "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + "|" + ENGLISH_DIGITS + "|" + ARABIC_DIGITS + "|" + ARABIC_EXT_DIGITS + "){1,199}",

    NAME_FA_NUMBER_FA_DESC : "باید حاوی حروف و اعداد فارسی باشد و با حرف شروع شود",

    NAME_FA_NUMBER_FA : NAME_FA_NUMBER_FA_ + "*",

    NAME_FA_NUMBER_FA_MEDIUM_DESC :"باید حاوی حروف و اعداد فارسی باشد و با حرف شروع شود و طول آن حداکثر ۴۰ کاراکتر باشد",
    NAME_FA_NUMBER_FA_MEDIUM : NAME_FA_NUMBER_FA_ + "{0,39}",



    TEXT_FA_DESC : "باید حاوی حروف و اعداد فارسی و علايم نگارشی باشد",
    TEXT_FA : TEXT_FA_ + "*",

    TEXT_FA_SMALL_DESC : "باید حاوی حروف و اعداد فارسی باشد و با حرف شروع شود و طول آن حداکثر ۵۰ کاراکتر باشد",
    TEXT_FA_SMALL : TEXT_FA_ + "{0,49}",

    TEXT_FA_MEDIUM_DESC : "باید حاوی حروف و اعداد فارسی باشد و با حرف شروع شود و طول آن حداکثر ۱۰۰ کاراکتر باشد",
    TEXT_FA_MEDIUM : TEXT_FA_ + "{0,99}",

    TEXT_FA_LARGE_DESC : "باید حاوی حروف و اعداد فارسی باشد و با حرف شروع شود و طول آن حداکثر ۲۰۰ کاراکتر باشد",
    TEXT_FA_LARGE : TEXT_FA_ + "{0,199}",

    TEXT_FA_XLARGE_DESC : "باید حاوی حروف و اعداد فارسی باشد و با حرف شروع شود و طول آن حداکثر ۵۰۰ کاراکتر باشد",
    TEXT_FA_XLARGE : TEXT_FA_ + "{0,499}",

    TEXT_FA_XXLARGE_DESC : "باید حاوی حروف و اعداد فارسی باشد و با حرف شروع شود و طول آن حداکثر ۱۰۰۰ کاراکتر باشد",
    TEXT_FA_XXLARGE : TEXT_FA_ + "{0,999}",

    TEXT_EN_FA : "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + ")" +
        "(" + ENGLISH_LETTERS + "|" + ARABIC_LETTERS + "|" + ARABIC_EXT_LETTERS + "|" + SPACE + "|" + PUNCTUATION +
        "|" + TAB_AND_NEW_LINE + "|" + ENGLISH_DIGITS + "|" + ARABIC_DIGITS + "|" + ARABIC_EXT_DIGITS + ")*",
    TEXT_EN_FA_DESC : "باید با حرف شروع شود",


    TITLE_EN_FA_DESC : "باید حاوی حروف و اعداد فارسی - انگلیسی و علايم نگارشی باشد",
    TITLE_EN_FA : TITLE_EN_FA_ + "*",

    TITLE_EN_FA_SMALL : TITLE_EN_FA_ + "{0,29}",
    TITLE_EN_FA_SMALL_DESC : "باید حاوی حروف و اعداد فارسی - انگلیسی و علايم نگارشی باشد و طول آن حداکثر ۳۰ کاراکتر باشد",

    TITLE_EN_FA_MEDIUM : TITLE_EN_FA_ + "{0,49}",
    TITLE_EN_FA_MEDIUM_DESC : "باید حاوی حروف و اعداد فارسی - انگلیسی و علايم نگارشی باشد و طول آن حداکثر ۵۰ کاراکتر باشد",

    TITLE_EN_FA_LARGE : TITLE_EN_FA_ + "{0,79}",
    TITLE_EN_FA_LARGE_DESC : "باید حاوی حروف و اعداد فارسی - انگلیسی و علايم نگارشی باشد و طول آن حداکثر ۸۰ کاراکتر باشد",
}

export function match(regx,input) {
    return new RegExp(regx).test(input)
}

export default patterns
